import React from "react";
import { Button } from "primereact/button";
import styles from "./LocationBanner.module.scss";

const LocationBanner = ({ locationError, getCurrentLocation }) => {
    if (!locationError) return null;

    return (
        <div className={styles.locationBanner}>
            <i className="pi pi-exclamation-triangle" />
            <span>{locationError}</span>
            <Button icon="pi pi-refresh" text size="small" onClick={getCurrentLocation} className={styles.retryLocationButton} />
        </div>
    );
};

export default LocationBanner;
